
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetohyderabadinnovarentalcab() {



    const cardData =
    {
        keyword: 'Pune to Hyderabad Innova Rental Cab ',
        heading: 'S9 Travels: Pune to Hyderabad Innova Rental Cab ',
        headingDescription: 'S9 Travels offers premium Innova rental cab services for travelers going from Pune to Hyderabad. Whether you’re traveling for business, a family vacation, or a personal trip, our fleet of well-maintained Innovas ensures a safe, reliable, and comfortable travel experience. The distance between Pune and Hyderabad is approximately 660 km, and the journey typically takes around 10 to 11 hours by road. With S9 Travels, you can enjoy a smooth and hassle-free ride to one of the most dynamic cities in India.',

        top: 'Top Places to Visit in Hyderabad with S9 Travels',

"topPlaces": [
    {
      "title": "Charminar",
      "description": "Charminar is one of the most iconic landmarks in Hyderabad. This 16th-century monument, built by Sultan Mohammed Quli Qutb Shah, features stunning Indo-Islamic architecture. Visitors can climb to the top for a panoramic view of the old city and explore the bustling markets around it, especially Laad Bazaar."
    },
    {
      "title": "Golconda Fort",
      "description": "Golconda Fort is a magnificent fortress known for its impressive architecture and rich history. Located on a hilltop, it offers a stunning view of the surrounding area. The fort is famous for its acoustics and the royal court, and visitors can explore its grand gates, palaces, and gardens."
    },
    {
      "title": "Hussain Sagar Lake",
      "description": "Hussain Sagar Lake, one of the largest artificial lakes in India, offers scenic views and is perfect for boating. The massive Buddha statue on an island in the middle of the lake is a popular attraction. You can also enjoy the Necklace Road, which offers a beautiful promenade around the lake."
    },
    {
      "title": "Qutb Shahi Tombs",
      "description": "The Qutb Shahi Tombs are located near Golconda Fort and house the tombs of the Qutb Shahi dynasty rulers. These tombs, with their stunning architectural style, offer a glimpse into the history and culture of the Qutb Shahi dynasty and are surrounded by beautiful gardens."
    },
    {
      "title": "Chowmohalla Palace",
      "description": "Chowmohalla Palace is a magnificent royal residence that once served as the seat of the Nizams of Hyderabad. The palace boasts stunning architecture, beautiful courtyards, and grand halls that showcase the grandeur and richness of Hyderabad’s royal history."
    },
    {
      "title": "Ramoji Film City",
      "description": "Ramoji Film City is one of the largest film studio complexes in the world. It offers guided tours where visitors can explore various film sets, theme parks, and entertainment attractions. It's a fantastic spot for family fun, and you can also witness live shows and events."
    },
    {
      "title": "Salar Jung Museum",
      "description": "Salar Jung Museum is one of the largest art museums in India, home to a diverse collection of art, antiques, and manuscripts from around the world. Some of its notable exhibits include the Veiled Rebecca, a stunning marble sculpture, and the Persian carpets on display."
    },
    {
      "title": "Birla Mandir",
      "description": "Birla Mandir, located on a hilltop, offers panoramic views of the city and is dedicated to Lord Venkateshwara. The temple is made of white marble and features intricate carvings and sculptures. It is one of the most serene spots in Hyderabad."
    },
    {
      "title": "Nehru Zoological Park",
      "description": "For nature and animal lovers, Nehru Zoological Park is a must-visit. The zoo is home to a variety of animals, including tigers, lions, elephants, and a wide range of bird species. It also has a safari park, a butterfly park, and a reptile house, making it an ideal destination for families."
    },
    {
      "title": "Mecca Masjid",
      "description": "Mecca Masjid is one of the largest and oldest mosques in Hyderabad. Located near the Charminar, it’s an architectural marvel, featuring stunning Indo-Saracenic design and a peaceful ambiance. The mosque’s grand prayer hall is a place of worship and reflection."
    }
],

"services": [
    {
      "name": "Pune to Hyderabad Innova Taxi Service",
      "description": "Experience a comfortable and seamless journey with our Pune to Hyderabad Innova taxi service. Whether it's a one-way trip, round trip, or a group travel experience, our Innova cabs provide the perfect solution for long-distance travel."
    },
    {
      "name": "Book Pune to Hyderabad Innova Cab",
      "description": "Booking an Innova cab from Pune to Hyderabad is easy and convenient with our reliable service. Enjoy ample space, comfort, and luxury on your journey from Pune to Hyderabad with our well-maintained vehicles."
    },
    {
      "name": "Pune to Hyderabad One-Way Innova",
      "description": "If you are looking for a one-way trip from Pune to Hyderabad, our Innova one-way taxi service is the best option. With flexible pricing and comfortable seating, we ensure a smooth and relaxed journey."
    },
    {
      "name": "Pune to Hyderabad Round Trip Innova",
      "description": "Planning a round trip from Pune to Hyderabad? Our round trip Innova service provides a hassle-free, comfortable, and affordable way to travel. Customize your itinerary and enjoy a flexible trip."
    },
    {
      "name": "Pune to Hyderabad Innova Car Hire",
      "description": "Rent an Innova car for your travel needs between Pune and Hyderabad. Our Innova car hire service is perfect for long-distance travel, offering convenience, comfort, and a great travel experience."
    },
    {
      "name": "Pune to Hyderabad Luxury Innova",
      "description": "For those seeking a luxury travel experience, we offer premium Innova cabs with plush interiors, advanced amenities, and a smooth ride, ensuring your journey from Pune to Hyderabad is as luxurious as possible."
    },
    {
      "name": "Affordable Innova for Hyderabad from Pune",
      "description": "Travel to Hyderabad in style and comfort with our affordable Innova cabs. Enjoy competitive pricing, excellent service, and a stress-free journey, without compromising on comfort."
    },
    {
      "name": "Innova Rental for Hyderabad Travel",
      "description": "For a seamless and comfortable journey, rent an Innova for your travel to Hyderabad. Whether it's a short or long trip, our vehicles are perfect for any occasion, with all the space you need for a relaxing ride."
    },
    {
      "name": "Hyderabad Trip in Innova from Pune",
      "description": "Make your Hyderabad trip memorable by booking an Innova cab from Pune. Whether for leisure, business, or temple visits, our Innova taxis provide the ideal solution for your travel needs."
    },
    {
      "name": "Book Innova for Hyderabad Tour",
      "description": "Planning a sightseeing tour in Hyderabad? Book an Innova for your Hyderabad tour from Pune. Visit famous attractions like Charminar, Golconda Fort, and more while enjoying the comfort and convenience of a private taxi."
    },
    {
      "name": "Group Travel to Hyderabad with Innova",
      "description": "Traveling with family or friends? Our Innova taxis are spacious enough to accommodate large groups. Book a group travel Innova for your trip to Hyderabad and enjoy a comfortable and hassle-free journey."
    },
    {
      "name": "Innova Service for Hyderabad Journey",
      "description": "Looking for a reliable and comfortable vehicle for your Hyderabad journey? Choose our Innova service from Pune, and experience a safe and comfortable ride, with professional drivers who know the best routes."
    },
    {
      "name": "Book Outstation Innova from Pune",
      "description": "Need an Innova for outstation travel? Book an Innova taxi for your outstation trip from Pune to Hyderabad. Whether it's a family trip or a business visit, our Innova cabs provide the ideal travel solution."
    },
    {
      "name": "Pune to Hyderabad Private Taxi",
      "description": "For a personalized and exclusive experience, book a private Innova taxi from Pune to Hyderabad. Enjoy your own space, flexibility, and comfort, without any Shared travel arrangements."
    },
    {
      "name": "Hyderabad Temple Trip by Innova",
      "description": "If you’re planning a temple tour in Hyderabad, our Innova taxis are the perfect option. Visit temples like Birla Mandir or Chilkur Balaji Temple with ease and comfort, while enjoying a smooth ride in a private Innova."
    }
  ],

"tableData": [
  ["Book Pune to Hyderabad Innova Cab", "Pune to Hyderabad Innova Taxi Service"],
  ["Pune to Hyderabad One-Way Innova", "Pune to Hyderabad Round Trip Innova"],
  ["Pune to Hyderabad Innova Car Hire", "Pune to Hyderabad Luxury Innova"],
  ["Affordable Innova for Hyderabad from Pune", "Innova Rental for Hyderabad Travel"],
  ["Hyderabad Trip in Innova from Pune", "Book Innova for Hyderabad Tour"],
  ["Group Travel to Hyderabad with Innova", "Innova Service for Hyderabad Journey"],
  ["Book Outstation Innova from Pune", "Pune to Hyderabad Private Taxi"],
  ["Hyderabad Temple Trip by Innova", ""]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the importance of punctuality when traveling long distances. Whether you’re visiting Hyderabad for business, leisure, or a family trip, we ensure timely pickups and drop-offs, so you can have a stress-free and on-time experience."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "Our Toyota Innova cabs are the perfect choice for long journeys like Pune to Hyderabad. With comfortable seating, ample legroom, air conditioning, and a smooth ride, your travel experience will be pleasant, whether you’re traveling with family, friends, or colleagues."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are highly experienced in long-distance travel and familiar with the best routes from Pune to Hyderabad. They prioritize your safety, comfort, and convenience, ensuring that your journey is smooth and enjoyable. With their local expertise, you can trust them to navigate efficiently."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Pune to Hyderabad Innova rental. We provide a clear breakdown of all costs up front, with no hidden charges. You can plan your trip without worrying about unexpected costs."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our priority. Our Toyota Innova cabs are equipped with modern safety features such as airbags, seat belts, and GPS tracking. With S9 Travels, you can enjoy a safe and secure journey from Pune to Hyderabad."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "We understand that travel plans can be flexible, so S9 Travels operates 24/7. Whether you need an early morning ride or a late-night departure, our services are available to suit your schedule, making your travel experience easy and convenient."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Hyderabad Innova rental cab is simple and convenient. You can make a booking online through our website or mobile app, or contact our customer service team for personalized assistance. We ensure a smooth booking process every time."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "We offer customized travel packages to cater to your specific needs. Whether you want to make additional stops along the way, need sightseeing services, or have any special requests, we can tailor the trip to meet your preferences."
  }
]


























    }



    const faqData = [
        [
          {
            question: 'How can I book an Innova rental for Pune to Hyderabad?',
            answer: 'Booking your Innova rental is easy! You can reserve your ride online through our website or mobile app. Alternatively, you can contact our customer service team, who will assist you in making the booking.',
          },
          {
            question: 'What is the seating capacity of the Innova?',
            answer: 'The Toyota Innova can comfortably seat up to 6 passengers, making it ideal for family trips, group travel, or business journeys.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel from Pune to Hyderabad?',
            answer: 'Yes, our drivers are highly experienced and trained in handling long-distance journeys. They are familiar with the Pune to Hyderabad route, ensuring you a safe, comfortable, and smooth ride.',
          },
          {
            question: 'What payment options are available for booking the Innova rental?',
            answer: 'We offer several payment options, including cash, credit/debit cards, and online payment through our app. You can choose the most convenient method for your trip.',
          },
          {
            question: 'Can I book a round trip from Pune to Hyderabad?',
            answer: 'Yes, we can arrange round-trip bookings for your journey from Pune to Hyderabad. Simply provide us with your return details, and we’ll take care of the rest.',
          },
          {
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any extra charges for waiting time or detours will be clearly communicated to you in advance. We believe in full transparency when it comes to pricing.',
          },
          {
            question: 'Can I make extra stops during my trip to Hyderabad?',
            answer: 'Yes, you can make extra stops during your journey. Let us know during the booking process, and we’ll ensure that your trip is tailored to your needs, whether for sightseeing or other personal reasons.',
          },
          {
            question: 'What is the luggage allowance for the Innova rental?',
            answer: 'The Toyota Innova has ample space for standard luggage. If you have additional luggage or special requirements, please inform us during the booking process, and we will accommodate your needs.',
          },
          {
            question: 'Is S9 Travels available for corporate travel to Hyderabad?',
            answer: 'Yes, we offer corporate travel services to Hyderabad. Whether it’s for meetings, conferences, or group travel, we ensure a professional and comfortable experience for all corporate journeys.',
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Hyderabad Innova rental?',
            answer: 'S9 Travels offers a reliable, safe, and comfortable travel experience with experienced drivers, well-maintained vehicles, and affordable pricing. We are committed to providing you with a smooth and enjoyable journey to Hyderabad.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Vikram Patel',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“We had a fantastic experience with S9 Travels for our trip from Pune to Hyderabad. The Innova was spacious, comfortable, and well-maintained. The driver was professional and courteous, and the ride was smooth and enjoyable. We will definitely book with them again!”',
        },
        {
          name: 'Mrs. Ritu Sharma',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“S9 Travels made our journey to Hyderabad so much easier and more comfortable. The vehicle was perfect for our family, and the driver was friendly and knowledgeable. Highly recommend their service for long-distance trips!”',
        },
      ];
      
      
      
      

    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Hyderabad Innova Rental Cab",
        "description": "Book your comfortable Innova taxi for a smooth ride from Pune to Hyderabad. Available for one-way, round trip, and group travel, with both affordable and luxury options for your Hyderabad sightseeing or temple tour.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "650"
        }
      };
      
      


    return (
        <div>
         <Helmet>
        <title>Pune to Hyderabad Innova Rental Cab | Luxury & Affordable Taxi Service</title>
        <meta 
          name="description" 
          content="Book an Innova taxi for your journey from Pune to Hyderabad. Choose from one-way, round-trip, or group travel with luxury and affordable cab services for sightseeing, temple tours, and more." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/34.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetohyderabadinnovarentalcab;